import * as React from "react";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterSubscribe } from "../FooterSubscribe/FooterSubscribe";

export const Multicolumns = ({ id, globals, shop, settings, links, type }) => {
  return (
    <div className={type}>
      <div className={`footer-links`}>
        {links.map((list_links, id) => {
          switch (list_links.type) {
            case "list":
              return (
                <React.Fragment key={id}>
                  <div
                    className={`lg:w-[${list_links.settings.text_column_width}] ml-[${list_links.settings.margin_left_right_mobile}px] lg:ml-[${list_links.settings.margin_left_right_desktop}px]`}
                  >
                    <FooterLinks
                      id={id}
                      shop={shop}
                      globals={globals}
                      settings={settings}
                      list_links={list_links}
                      type={type}
                    />
                  </div>
                </React.Fragment>
              );
            case "email_subscribe":
              return (
                <React.Fragment key={id}>
                  <div
                    className={`lg:w-[${list_links.settings.text_column_width}] lg:mr-[112px]`}
                  >
                    <FooterSubscribe
                      id={id}
                      shop={shop}
                      globals={globals}
                      settings={settings}
                      list_links={list_links}
                    />
                  </div>
                </React.Fragment>
              );
          }
        })}
      </div>
    </div>
  );
};
